import classNames from 'classnames';

export function OptionsHeader({ children, className }) {
  return <h2 className={classNames('text-header-3 mb-3.75 flex items-center', className)}>{children}</h2>;
}
